export default {
  ViewRecord: '查看记录',
  Document: '文档',
  QA: '问答',
  WebsiteImport: '网站导入',
  Question: '问题：',
  Answer: '答案：',
  EnhancedSearch: '增强检索',
  selectOption: '请选择',
  clearMemory: '清除记忆',
  resetInput: '重置输入',
  startRunning: '开始运行',
  running: '运行中',

  PleaseSelectTriggerTime: '请选择触发时机',
  PleaseEnterTriggerContent: '请输入触发内容',
  Add: '新增',
  Delete: '删除',
  PrefixMatch: '前缀匹配',
  ContainMatch: '包含匹配',
  SuffixMatch: '后缀匹配',
  TriggerTime: '触发时机',
  TriggerContent: '触发内容',
  TriggerMechanism: '触发机制',
  Colon: '：',
  CopyApplication: '应用复制',
  ConfirmCopy: '将自动创建一个相同的应用，确认复制吗？',
  CopyConfirm: '确定复制',
  CopySuccess: '复制成功',
  Code: 'code:',
  CopySuccessful: '复制成功',
  ShareApplication: '分享应用',
  ApplicationLink: '应用链接:',
  StartChat: '开始对话',
  Drawing: '绘画',
  createApp: '创建应用',

  SetAIPromptToBuildBot: '设定AI提示词快速搭建Bot',

  SupportKnowledgeBaseAndDatabase: '支持知识库和数据库能力',
  AIAutoFill: 'AI一键填写',
  AIAutoFillTip: '填写应用名称和描��后，由AI帮你一键生成其他内容。注意对于"应用设定"这样的关键配置，建议在生成后进行优化，以获得更好的效果。',
  CopyFromTemplateCenter: '去模板中心复制',
  ApplicationName: '应用名称',
  EnterInterestingName: '给你的应用取一个有趣的名字吧',
  ApplicationDescription: '应用描述',
  IntroduceYourApp: '介绍下你的应用有什么功能吧',
  OpeningIntroduction: '开场介绍',
  OpeningIntroTip: '这是用户在网页端首次使用时，智能应用向用户发送的第一条消息，支持Markdown格式。且支持使用 "[]" 符号生成可以点击发送的引导问题，例如:',
  smartAssistantPrompt: '我是你的智能助手，你可以问我:',
  OpeningIntroExample: '- [如何进行活动策划?]',


  ApplicationAvatar: '应用头像',
  AvatarCreationIdea: '头像创作思路',
  IsPublic: '是否公开',
  PublicTip: '(如选择公开则可在应用广场被搜索和使用)',
  SelectCategory: '选择分类',
  SelectAppCategory: '请选择应用分类',
  ApplicationSettings: '应用设定',
  ApplicationSettingsTip: '应用设定非常重要，决定了机器人的人物设定、功能和工作特征，请尽可能用详细的自然语言进行描述，越具体效果越好哦',
  KnowledgeBaseBinding: '知识库绑定',
  SelectKnowledgeBase: '选择知识库',
  View: '查看',
  UploadFile: '上传文档',
  UnstructuredDocument: '无结构文档',
  AutoParseDocument: '自动解析文档, 使用方便',
  QAFormat: 'QA问答格式',
  ImportQA: '一问一答导入, 准确性更加',
  BindExistingKnowledgeBase: '绑定已有知识库',
  CreateApplication: '创建应用',
  ApplicationCreationSuccess: 'AI应用创建成功',
  IntegrateToSystem: '同时你还可以将应用接入到各APP中',
  QuickIntegration: '快速接入',
  ApplicationSettingsExample: {
    prompt: '例如：请扮演面试官，就"产品经理"这一岗位向候选人提出面试问题，一次只需要问一个问题，并等待候选人的回答',
    embedding: '例如：请扮演LinkAI平台的智能客服，根据知识库中提供的已知信息，解答用户有关LinkAI使用的问题'
  },
  Yes: '是',
  No: '否',
  SelectCategoryPlaceholder: '请选择应用分类',
  DragFileOrClickUpload: '拖入文件 或 <em>点击上传</em>',
  SupportedFileFormats: '支持 txt, pdf, md, docx 格式文件,\n大小不超过10M，创建完成后可继续添加知识库文件',
  SupportCSVFile: '支持 csv 文件，点击',
  DownloadTemplate: '下载模板',
  SaveAsUTF8: '，注意：需保存为 UTF-8 格式',
  Cancel: '取消',
  CreateApp: '创建应用',
  ApplicationCreatedSuccessfully: 'AI应用创建成功',
  GeneratedApplicationLink: '已为你生成专属的应用链接',
  DebugNow: '立即测试',
  CopyLink: '复制链接',
  IntegrateToApps: '你还可以将应用接入到各APP中',
  // Tooltips for icons
  ConversationAPI: '对话API',
  WebEmbed: '网页嵌入',
  WeChat: '微信',
  WeChatWork: '企微',
  WeChatOfficialAccount: '微信公众号',
  Feishu: '飞书',
  WeChatService: '微信客服',
  DingTalk: '钉钉',
  QuickAccess: '快速接入',
  CopyCode: '复制Code',
  Confirm: '确定',
  ApplicationSettingsDialog: '应用设定',
  ImageUploadFormatError: '图片上传只支持 jpeg,png 格式',
  ImageSizeError: '图片大小需小于 5MB!',
  Official: '官方',
  PleaseUploadDocFormat: '请上传 txt, pdf, md, docx 格式文件',
  PleaseUploadCSVFormat: '请上传 csv 格式文件',
  PleaseEnterNameAndDesc: '请输入应用名称和描述~',
  PleaseEnterDesc: '请输入应用描述',
  DescriptionLengthTip: '应用描述需要超过5个字',
  PleaseEnterIntro: '请输入开场介绍',
  IntroLengthTip: '开场介绍需要超过5个字',
  PleaseUploadAvatar: '请上传头像',
  PleaseSelectCategory: '请选择应用分类',
  PleaseEnterSettings: '请输入应用设定',
  PleaseUploadDoc: '请上传文档',
  DefaultAvatarTip: '布场不用默认头像哦~',
  CreatingApplication: '知识应用创建中，数据处理需要一定时间，请耐心等待~',
  FileEncodingError: '文件编码错误，请保存为utf-8格式后上传， 或联系客服处理',
  TokenLimitExceeded: '大小超限，单个应用token数不超过100w，额外需求请联系客服',
  CreateApplicationFailed: '创建应用失败',
  KnowledgeBaseUpdating: '知识库更新中，请稍等~',
  PleaseEnterAppName: '请输入应用名称！',
  PleaseEnterAppDesc: '请输入应用描述！',
  FileUploadSizeLimit15: '文件大小需小于 15MB!',
    appNameAndDescription: '请先填写应用名称和应用描述',
  AppDescLengthTip: '应用描述需要超过5个字~',
  AutoGenerating: '正在帮您一键生成中，请耐心等待~',
  BasicConfiguration: '基础配置',
  RateLimit: '限流配置',
  AdvancedConfiguration: '高级配置',
  Debug: '调试',
  Save: '保存', // 已存在
  StandardFeature: '标准版功能',
  VersionDescription: '版本说明',
  ProFeature: '专业版功能',
  VipFeature: 'VIP功能',
  AddConfiguration: '新增配置',
  NoRateLimitConfig: '当前无限流配置，请点击右上角按钮新增。',
  ByUsageFrequency: '按使用频率',
  ConfirmDelete: '确定删除吗?',
  Target: '针对',
  Channel: '渠道，',
  SingleUserPer: '单用户每',
  CanOnlyReply: '，只能回复',
  Messages: '条。',
  ReplyWhenExceeded: '超制时回复:',
  NoReplyByDefault: '默认不回复',
  // Time units
  Second: '秒',
  Minute: '分钟',
  Hour: '小时',
  Day: '天',
  // Channel options 
  All: '全部',
  PersonalSubscription: '个人订阅号',
  EnterpriseOfficialAccount: '企业公众号',
  WeChatWorkInternalApp: '企业内部应用',
  // Messages
  DeleteSuccess: '删除成功',
  DeleteFailed: '删除失败',
  UnsavedConfigTip: '您有未保存的配置，请先进行保存。',
  RequestFailed: '请求失败',
  InvalidRateLimitRule: '请正确设置限流规则，不可填写0',
  SavingData: '保存中，数据处理需要一定时间，请耐心等待~',
  SaveSuccess: '保存成功',
  SaveFailed: '保存失败',
  // Model selection translations
  Model: '模型',
  SelectModel: '选择模型',
  Plugins: '插件',
  IntelligentTransfer: '智能转人工',
  ConfigurationItem: '配置项',
  Status: '状态',
  Operation: '操作',
  Enabled: '已启用',
  Disabled: '未启用',
  Configure: '配置',
  Humanization: '拟人化',
  PromptOptimization: '提示词优化',
  SplitReply: '分段回复',
  SplitReplyTip: '对于长内容将随机拆分为多段进行回复',
  MergeReply: '合并回复',
  MergeReplyTip: '对于短时间内的多个问题，将进行汇总后一次性回复。该功能需要设置下方 "延���回复" 时后才能生成',
  DelayReply: '延迟回复',
  DelayReplyTip: '额外延迟一定时间后再进行内生成和回复',
  Seconds: '秒',
  PleaseSelectTriggerMethod: '请选择触发方式',
  PleaseEnterIntentKeyword: '请填写意图/关键词',
  SaveSuccessful: '保存成功',
  PleaseSetDelayTime: '合并回复会将短时间内的问题汇总到一起回复，需设置延迟回复时间才会生效。',
  SavingInProgress: '保存中，数据处理需要一定时间，请耐心等待~',
  // Database Setting translations
  DatabaseSettings: '数据库设置',
  DatabaseSettingsTip: '对话时首先根据用户问题、数据库的名称和描述选择是否需要操作数据库，再根据数据表描述及各字段的名称和描述生成SQL语句。',
  BindDatabase: '绑定数据库',
  NoDatabase: '暂无数据库',
  CreateDatabase: '新建数据库',
  RefreshDatabase: '刷新数据库',
  BindDatabaseTip: '可绑定多个数据库，已绑定的数据库取消勾选并保存后可取消绑定。',
  BuiltInDatabase: '内置数据库',
  RemoteDatabase: '远程数据库',
  ViewDetails: '查看',
  BindingSuccessful: '绑定成功',
  CancelBinding: '取消绑定',
  ConfirmCancelBinding: '确定取消绑定？',
  Empty: '空空如也',
  // Intelligent Transfer related
  ManualServiceConfiguration: '转人工配置',
  TriggerConfiguration: '触发配置',
  TriggerTimingTip: '当用户最近一次提问满足下列设置的任意条件时，可触发转人工',
  TriggerMethod: '触发方式',
  IntentKeyword: '意图/关键词',
  KeywordMatch: '关键词匹配',
  IntentRecognition: '意图识别',
  PleaseEnter: '请输入',

  // Reply Configuration
  ReplyConfiguration: '回复配置',
  DefaultReply: '默认回复',
  DefaultReplyTip: '触发转人工后，智能体向用户发送的默认回复（仅回复一次）',
  ReplyMode: '回复模式',
  ReplyModeTip: '转为人工后，有三种模式可选',
  ReplyModeDetail: '1. 不回复：转人工后，AI不回复用户的后续提问，需在「对话管理」中手动切换为AI回复后方能继续回复\n2. 继续回复：转人工后，AI仍继续回复用户的后续提问\n3. 延迟回复：转人工后，AI会在指定的延迟时间后自动切换为AI回复，在此期间不回复用户',
  NoReply: '转人工后不回复',
  ContinueReply: '转人工后继续回复',
  DelayedReply: '转人工后延迟回复',
  DelayedTime: '延迟',
  MinutesAutoSwitch: '分钟后自动转回AI回复',

  // Notification Configuration
  NotificationConfiguration: '通知配置',
  NotificationMethod: '通知方式',
  NotificationEmail: '邮箱',
  SMSNotification: '短信',
  NotificationEmailTip: '转人工后系统向指定的邮箱发送提醒',
  SMSNotificationTip: '转人工后系统向指定空间成员LinkAI账号定的手机号发送信提醒',
  WeChatMPNotification: '公众号',
  WeChatMPNotificationTip: '转人工后系统通过"LinkAI平台"公众号向指定空间成员LinkAI账号绑定的微信发送消息提醒',
  WebhookNotification: 'Webhook群机器人',
  WebhookNotificationTip: '转人工后系统通过配置的Webhook群机器人向企微/钉钉/飞书内部群聊发送提醒，将使用依据"摘要模板"生成的总结作为提醒内容',

  // Space Members
  SpaceMembers: '空间成员',
  ConfigureWebhook: '配置Webhook',
  WebhookChannel: 'Webhook渠道：',
  PleaseConfigureWebhook: '请配置Webhook',

  // Summary Configuration
  IntelligentSummary: '智能总结',
  SummaryTemplate: '摘要模版',
  SummaryTemplateTip: '转人工后，AI将根据配置的模板，基于和用户的聊天内容生成智能总结，并于转人工时在「对话管理」中展示，也用于转人工后通过Webhook通知到群聊',
  TemplateTipDetail: '设置模板时，添加希望AI总结的内容，并用自然语言描述该内容的具体含义，以便AI根据描述进行生成。\n例："内容：购买意向；描述：如果客户表达想要购买xx产品，则为"是"，否则为"否""',
  Content: '内容',
  Description: '描述',

  // AI打标签
  AITagging: 'AI打标签',
  AITaggingTip: '转工时，AI将根据所标签的标签述，基于和用户的聊天内容判断是否符合该标签，如符合则为用户自动添加该标签，并在「客户管理」中展示',
  SelectReference: '选择引用',

  // 提示消息
  PleaseSelectNotifyMembers: '请选择要通知的空间成员',
  PleaseEnterSummaryTemplate: '请输入摘要模版',
  SaveInProgress: '保存中，数据处理需要一定时间，请耐心等待~',

  // 渠道相关
  DingTalkBot: '钉钉群机器人',
  FeishuBot: '飞书群机器人',
  WeChatWorkBot: '企微群机器人',
  AddWebhookDingTalk: '请在钉钉群中添加自定义机器人，并获取Webhook地址：',
  AddWebhookFeishu: '请在飞书群中添加自定义机器人，并获取Webhook地址：',
  AddWebhookWecom: '请在企微内部群中添加群机器人，并获取Webhook地址：',
  DingTalkSecret: '钉钉群机器人安全设置选择"加签"，并获取密钥：',
  FeishuSecret: '飞书群机器人安全设置选择"签名校验"，并获取密钥：',

  IntentKeywordTip: '触发方式为关键词匹配，设置关键词，当用户提问包含关键词则转人工\n触发方式为意图识别，用自然语言描述触发转人工的用户意图，当用提问的语义满足该意图则转人工',
  KeywordMatchOption: '关键词匹配',
  IntentRecognitionOption: '意图识别',
  // Form placeholders
  PleaseEnterContent: '请输入',
  BindKnowledgeBase: '绑定知识库',
  BindKnowledgeBaseTip: '可绑定多个知识库，已绑定的知识库再次点击后可取消。',
  RefreshKnowledgeBase: '刷新知识库',
  CreateKnowledgeBase: '新建知识库',
  EmptyKnowledgeBase: '空空如也',
  ConfirmBinding: '确认绑定',
  BasicInfo: '基础信息',
  AppCode: '应用Code',
  AppName: '应用名称',
  DeleteApp: '删除应用',
  AppType: '应用类型',
  AppAvatar: '应用头像',
  AutoGenerate: '自动生成',
  UpgradeToKnowledgeAppTip: '升级为知识应用，上传文档和数据打造专属智能体',
  AppShare: '应用分享',
  Public: '公开',
  ExclusiveLink: '专属链接',
  AppDescription: '应用描述',
  OpeningIntro: '开场介绍',
  FirstMessagePlaceholder: '应用的第一句话。例如:有什么可以帮您的?',
  modelSettings: '模型设置',
  defaultModel: '默认模型',
  defaultModelForService: '应用接入渠道提供服务时使用的默认模型',
  OptionalModels: '对话可选模型',
  OptionalModelsTip: '调试及在网页端对���时用户可切换的模型',
  sound: '声音',
  Memory: '记忆',
  MemoryTip: '对话时保持记忆的上下文轮次，每一轮包��一条提问和一条回复',
  SelectMemoryContextTurns: '请选择记忆上下文次数',
  Turns: '轮',
  RetainFor: '保留',
  Minutes: '分钟',
  Temperature: '温度',
  TemperatureTip: '温度越高回复越具有创意和不确定性，温度越低则回复更严谨',
  appSettingsImportance: '应用设定非常重要，决定了智能体的人物设定、功能和工作特征，请尽可能用详细的自然语言进行描述，越具体效果越好哦',
  knowledgeBaseConfig: '知识库配置',
  RetrievalMethod: '检索方式',
  SemanticSearch: '语义检索',
  EnhancedRetrieval: '增强检索',
  SemanticSimilarityThreshold: '语义相似度阈值',
  SingleSearchCount: '单次检索条数',
  SemanticSearchCount: '语义检索条数',
  FullTextSearchCount: '全文检索条数',
  NoHitStrategy: '未命中策略',
  FreeStyle: '自由发挥',
  FixedText: '固定文案',
  ManualService: '转人工',
  KnowledgeBaseSource: '知识库引用来源',
  Enableds: '开启',
  Disableds: '关闭',
  noKnowledgeBase: '暂无知识库',

  PluginConfiguration: '插件配置',
  AddPlugin: '添加插件',
  AddPluginTitle: '添加插件',
  CreatePlugin: '创建插件',
  ShowThinkingProcess: '展示思考过程',
  PluginExecutionProcess: '插件执行过程',
  MultiRoundThinking: '多轮思考',
  MultiRoundThinkingTip: 'Agent模式，即通过多次思考和使用插件来完成任务的能力 (beta版本)',
  MaxThinkingRounds: '最大思考轮数',
  SelectMaxThinkingRounds: '请选择最大思考轮数',
  PluginExecutionStrategy: '插件执行策略',
  knowledgeBasePriority: '知识库优先：对于用户问题优先去知识库中检索，未命中才会选择插件',
  pluginPriority: '插件优先：优先决策插件，插件未命中时才尝试检索知识库',
  executeKnowledgeBaseAndPluginsSimultaneously: '知识库与插件同时执行：每次请求都会尝试检索知识库和选择插件，并将二者的结果汇总后进行问题回答',

  selectPluginExecutionPolicy: '请选择插件执行策略',
  noPluginsAvailable: '暂无插件',
  bindMultipleKnowledgeBases: '可绑定多个知识库，已绑定的知识库取消勾选并保存后可取消绑定。',
  confirmation: '确认',
  searchConfiguration: '检索配置',

  semanticVectorSearch: '通过语义向量搜索相关文本',
  enhancedSearchWithSemanticVector: '通过语义向量叠加全文（关键字）检索混合增强搜索相关文本',
  semanticSimilarityThreshold: '只有知识库条目的语义相似度高于该阈值时才会被检索，可以在 "知识库 - 检��测试" 中进行测试：',
  highSemanticSimilarity: '高语义相似度时',
  lowSemanticSimilarity: '低语义相似度时 (如0.7以下)，可能会检索出相关性低的内容，但检索范围更大',
  maxParagraphsForSingleQnA: '单次问答从知识库中进行语义检索的最大段落数量，默认为3，条数增加会增大token消耗，注意不要超过模型最大上下文。',
  maxParagraphsForKeywordSearch: '单次问答从知识库中进行全文关键词检索的最大段落数量，默认为1，增加会增大token消耗，注意不要超过模型最大上下文。',

  maxSearchResults: '全文检索条数加语义检索条数之和最大为10，优先满足语义检索条数设置',
  noMatchingKeywords: '若实际使用时无匹配的关键词，则增强全文检索的实际结果可能为0',
  fullTextSearchHint: '提示：全文检索为语义检索的补充，两者条数之和最大为10，优先满足语义检索条数设置',
  noSimilarContentStrategy: '未找到知识库中相似内容时的策略',
  freePlay: '自由发挥: 由AI根据应用设定自行推理并回复',
  fixedResponse: '固定文案: 根据指定文本进行回复',
  transferToHuman: '转人工：依据应用高级配置-转人工配置中的规则提醒人工处理',
  pleaseEnterCopy: '请输入文案。',
  knowledgeBaseSource: '展示知识库引用来源',
  showKnowledgeBaseSource: '开启后，如提问命中知识库内容，将在回复中展示知识库内容出处的文件名、网站名和网址，如图所示：',
  knowledgeBaseCitationDisplayThreshold: '知识库引用展示阈值',
  knowledgeBaseSearchResults: '知识库检索结果中一般包含多条内容，模型在生成回复时一般会参考与问题相关度更高的知识库内容而并非所有的检索结果。',
  setThreshold: '设置该阈值后，在展示知识库引用来源时只展示相似度满足该阈值的检索结果。需设置大于等于「检索配置」中的"语义相似度阈值"。',
  confirmConfiguration: '确认配置',
  modelSelection: '模型选择',
  selectModel: '请选择模型',
  generalLargeModel: '通用大模型',
  industryLargeModel: '行业大模型',
  maxContext: '最大上下文',
  ShowcasingThoughtprocess: '展示思考过程',
  confirmConfigurationModel: '确认配置模型',
  customPlugin: '自定义插件',
  added: '已添加',
  builtInPlugin: '内置插件',
  confirmAdd: '确s认添加',

  Descriptions: '描述：',
  Introductions: '说明：',
  Prices: '价格：',
  PointsPerTime: '积分/次',
  PointsPerThousandTokens: '积分/千tokens',
  PriceDetails: '详情查看',
  ViewPriceDoc: '价格文档',
  ConfigureKey: '配置Key',
  Creator: '创建人：',
  ConfirmConfiguration: '确认配置',
  firstSentenceOfApp: '应用的第一句话。例如:有什么可以帮您的?',
  oneClickOptimize: '一键优化',
  optimizationInProgress: '优化中',
  optimizationCompleted: '优化完成',
  stopOutput: '停止输出',
  prompt: '提示：',
  bindKnowledgeBase: '可以在这里绑定你的知识库，让应用基于上传的知识内容，提供个性化的智能问答。',
  maximized: '已最大',
  pluginPrioritys: '插件优先',
  knowledgeBasePrioritys: '知识库优先',
  knowledgeBaseAndPluginsExecution: '知识库与插件同时执行',
  imageUploadSupportedFormats: '图片上传只支持 jpeg,png 格式',
  imageSizeLimit: '图片大小需小于 5MB!',
  confirmUpgradeToKnowledgeApplication: '是否确认升级为知识应用',
  upgradeApp: '升级应用',
  confirmUpgrade: '确定升级',
  upgradeSuccess: '升级成功',
  playbackFailedContactAdmin: '播放失败，请联系管理员。',
  appDeletionWarning: '应用删除后数据将无法恢复，是否确定删除?',
  deleteApp: '删除应用',
  confirmDeletion: '确定删除',
  deleteSuccess: '删除成功',
  pleaseEnterAppDescription: '请输入应用描述！',
  appDescriptionTooShort: '应用描述需要超过5个字~',
  pleaseEnterAppIntroduction: '请输入应用介绍！',
  appIntroductionTooShort: '应用介绍需要超过5个字~',
  pleaseUploadImage: '请上传图片！',
  pleaseAddModel: '请添加模型！',
  pleaseSelectDefaultModel: '请选择默认模型！',
  defaultAvatarWarning: '发布到广场不能使用默认头像哦~',
  appSavingMessage: '应用保存中，数据处理需要一定时间，请耐心等待~',
  saveSuccessMessage: '保存成功',
  saveFailureMessage: '修改应用失败',
  knowledgeBaseBound: '当前知识库已绑定',
  bindingKnowledgeApplication: '知识应用绑定中，请稍等等待~',
  knowledgeBaseUpdating: '知识库更新中，请稍等~',
  configurationSuccess: '配置成功',
  enableHumanTransferInAdvancedSettings: '请先在应用高级配置中开启转人工。',
  linkAIIntelligentCustomerService: '请扮演LinkAI平台的智能客服，根据知识库种提供的已知信息，解答用户有关LinkAI使用的问题',
  interviewQuestionForProductManager: '请扮演面试官，就"产品经理"这一岗位向候选人提出面试问题，一次只需要问一个问题，并等待候选人的回答。',
  modelRetrievalLengthCannotBeZero: '模型检索长度不能为0',
  closeSuccess: '关闭成功',
  selectPlugin: '请选择插件',
  doNotAddPluginsAgain: '请勿重复添加插件。',
  successfullyEnabled: '开启成功',
  addSuccess: '添加成功',
  confirmDeletePlugin: '是否确定删除该插件',
  removePlugin: '删除插件',

  generationFailed: '生成失败!',
  CannotBeEmpty: '不能为空。',
  viewDetails: '查看详情',
  deleteChatHistoryConfirmation: '删除将清空此角色的聊天记录，是否确认删除?',
  deleteChat: '删除聊天',
  stopRunning: '停止运行',
  runYourCreativity: '运行你的创意 ~',

  taskSubmitting: '任务提交中,请耐心等待',
  stopConversation: '停止对话',
  makeSameStyle: '制作同款',

  host: '主机',
  TransferToHuman: '转人工配置',
}